import {App, createApp} from "vue";
import {createI18n} from 'vue-i18n'

import GetStartedBlock from "@/components/getStartedBlock/GetStartedBlock.vue";
import SearchBar from "@/components/search/SearchBar.vue";
import SpeachSlider from "@/components/speachSlider/SpeachSlider.vue"
import SpeachGrid from "@/components/speachGrid/SpeachGrid.vue"
import NotificationHeaderApp from "@/components/notifications/NotificationHeaderApp.vue";
import NotificationPageApp from "@/views/notification/NotificationPageApp.vue";
import Dashboard from "@/views/dashboard/Dashboard.vue"
import Loader from "@/components/loader/Loader.vue"
import MyAccount from "@/views/myAccount/MyAccount.vue"
import {ObserveVisibility} from 'vue-observe-visibility'
import Grid from "@/components/grid/Grid.vue"
import EditVideoChapter from "@/components/chapter/EditVideoChapter.vue"
import Footer from "@/components/footer/Footer.vue"
import AccessibilityStatementVue from "@/views/accessibility/AccessibilityStatementVue.vue"
import AccessibilityStatementEditVue from "@/views/accessibility/AccessibilityStatementEditVue.vue"
import ShareChapterWithSelector from "@/components/chapter/ShareChapterWithSelector.vue"
// @ts-ignore
import Cookies from 'js-cookie'

import en from '@/locales/en.json';
import fr from '@/locales/fr.json';
import de from '@/locales/de.json';
import es from '@/locales/es.json';
import "@/scss/global.scss";
import "@/types/legacyGlobals";
import {Events} from "@/events/events";
import GcuAgreementScreen from "@/views/gcu/GcuAgreementScreen.vue";
import GcuConsultScreen from "@/views/gcu/GcuConsultScreen.vue";
import PdpAgreementScreen from "@/views/pdp/PdpAgreementScreen.vue";
import PdpConsultScreen from "@/views/pdp/PdpConsultScreen.vue";
import WorkflowGraph from "@/components/workflow/WorkflowGraph.vue";
import EditDocumentChapter from "@/components/editDocumentChapter/EditDocumentChapter.vue";
import ResetQuizButton from "@/components/quiz/ResetQuizButton.vue";
import ExportMassScorm from "@/views/exportMassScorm/ExportMassScorm.vue";
import ExportCsv from "@/views/exportCsv/ExportCsv.vue";
import PathEditor from "@/views/pathEditor/PathEditor.vue";
import axios from "axios";
import {redirectIfLogin} from "@/util/loginUtils";
import AdminListUsers from "@/views/admin/users/AdminListUsers.vue";
import ConvertQuizToExamLink from "@/components/quiz/ConvertQuizToExamLink.vue";
import AdminListSpeaches from "@/views/admin/speaches/AdminListSpeaches.vue";
import AudioTrackLoader from "@/components/video/AudioTrackLoader.vue";
import AlertDialog from "@/components/dialogs/AlertDialog.vue";
import InformationDialog from "@/components/dialogs/NotificationDialog.vue";
import UnsubscribeEmailNotificationSuccess from "@/views/notification/UnsubscribeEmailNotificationSuccess.vue";
import DueDateSettings from "@/views/speach/DueDateSettings.vue";
import WeetChapter from "@/views/recorder/WeetChapter.vue";
import WeetPlayerChapter from "@/views/player/WeetPlayerChapter.vue";
import AIAdminPanel from "@/views/aiAdminPanel/AIAdminPanel.vue";
import CreateAudioFromText from "@/views/recorder/CreateAudioFromText.vue";
import AISpeachGenerator from "@/views/aiCreator/AISpeachGenerator.vue";
import AISpeachGeneratorInitiator from "@/components/aiSpeachGenerator/AIChapterContentGeneratorInitiator.vue"
import GenerationInProgress from "@/components/aiSpeachGenerator/GenerationInProgress.vue";
import SpeachGenerationLoader from "@/components/aiSpeachGenerator/SpeachGenerationLoader.vue";
import AIQuizGenerator from "@/components/aiQuizGenerator/AIQuizGenerator.vue";
import WorkflowValidation from "@/views/speach/WorkflowValidation.vue";
import VersioningVideoDownloadButton from "@/components/versioning/VersioningVideoDownloadButton.vue";
import AdminListPeriodicReviews from "@/views/admin/speaches/AdminListPeriodicReviews.vue";
import Logout from "@/views/authentication/logout.vue";
import ScormExportDialog from "@/components/speach/ScormExportDialog.vue";
import UnlockViewSettings from "@/views/speach/UnlockViewSettings.vue";
import AnonymousWorkflowSubmit from "@/views/speach/AnonymousWorkflowSubmit.vue";
import OpenQuestionQuizPlayer from "@/views/player/quiz/OpenQuestionQuizPlayer.vue";
import SuccessQuizPlayer from "@/views/player/quiz/SuccessQuizPlayer.vue";
import SurveyQuizPlayer from "@/views/player/quiz/SurveyQuizPlayer.vue";
import PollQuizPlayer from "@/views/player/quiz/PollQuizPlayer.vue";
import PollQuizStatistics from "@/components/quiz/PollQuizStatistics.vue";
import SpeachPollsResults from "@/components/speach/analytics/SpeachPollsResults.vue";
import SimpleQuizPlayer from "@/views/player/quiz/SimpleQuizPlayer.vue";
import ExamQuizPlayer from "@/views/player/quiz/ExamQuizPlayer.vue";
import UserQuizzesResultsDialog from "@/components/speach/analytics/UserQuizzesResultsDialog.vue";
import FillInTheBlanksQuestionEdit from "@/components/questions/fillInTheBlanks/FillInTheBlanksQuestionEdit.vue";
import MatchingQuestionEdit from "@/components/questions/matching/MatchingQuestionEdit.vue";
import SortingQuestionEdit from "@/components/questions/sorting/SortingQuestionEdit.vue";
import ChapterPageEditor from "@/components/chapter/ChapterPageEditor.vue";
import ChapterDocumentViewer from "@/components/chapter/ChapterDocumentViewer.vue";
import VeevaAISpeachLoader from "@/views/veeva/VeevaAISpeachLoader.vue";
import AnswerImageUploaderLegacyWrapper from "@/components/questions/AnswerImageUploaderLegacyWrapper.vue";
import SpeachTranslationSettings from "@/components/translation/SpeachTranslationSettings.vue";
import QuizQuestionCorrectionEditor from "@/components/quiz/QuizQuestionCorrectionEditor.vue";
import QuizQuestionComplementaryInfoEditor from "@/components/quiz/QuizQuestionComplementaryInfoEditor.vue";
import SuccessChapterView from "@/views/speach/chapter/SuccessChapterView.vue";
import OpenQuestionChapterView from "@/views/speach/chapter/OpenQuestionChapterView.vue";
import ThumbnailGeneratorModal from "@/components/thumbnailGenerator/ThumbnailGeneratorModal.vue";
import DemoEditorLock from "@/components/demo/DemoEditorLock.vue";
import DemoHome from "@/components/demo/DemoHome.vue";
import CrispSupport from "@/components/support/CrispSupport.vue";
import DiagramChapterEditor from "@/views/speach/chapter/DiagramChapterEditor.vue";
import DiagramChapterViewer from "@/views/speach/chapter/DiagramChapterViewer.vue";


const i18n = createI18n({
    globalInjection: true,
    locale: Cookies.get("PLAY_LANG"),
    fallbackLocale: 'en',
    legacy: false,
    messages: {
        fr: fr,
        en: en,
        de: de,
        es:es
    }}
)
// createApp(App).mount('#app')

const mountElement = (el: Element) => {
    const app = createApp({})
    app.use(i18n);
    app.directive("observe-visibility", {
        beforeMount: (el, binding, vnode) => {
            (vnode as any).context = binding.instance
            ObserveVisibility.bind(el, binding, vnode)
        },
        updated: ObserveVisibility.update,
        unmounted: ObserveVisibility.unbind,
    });

    // This directive allows to add an action when clicking outside a coomponent
    app.directive('click-outside', {
      beforeMount: (el, binding) => {
        //  check that click was outside the el and his children
        el.clickOutsideEvent = (event: { target: any; }) => {
          const sidePanelFilterArray = Array.from(document.querySelectorAll('.sidepanel-click-filter'));
          const clickedInsideSidePanel = sidePanelFilterArray.length && (sidePanelFilterArray.some((filteredElement)=>filteredElement===event.target|| filteredElement.contains(event.target)));

          if (!(el == event.target || el.contains(event.target) || clickedInsideSidePanel)) {
            binding.value(event, el);
          }
        };
        document.addEventListener("mousedown", el.clickOutsideEvent);
      },
      unmounted: el => {
        document.removeEventListener("mousedown", el.clickOutsideEvent);
      },
    });

    // component
    app.component("get-started-block", GetStartedBlock);
    app.component("search-bar",SearchBar);
    app.component("notification-header-app",NotificationHeaderApp)
    app.component("reset-quiz-button", ResetQuizButton)
    app.component("loader",Loader)
    app.component("speach-slider",SpeachSlider)
    app.component("speach-grid",SpeachGrid);
    app.component("grid",Grid)
    app.component("edit-video-chapter",EditVideoChapter)
    app.component("edit-document-chapter",EditDocumentChapter)
    app.component("workflow-graph",WorkflowGraph)
    app.component('audioTrackLoader',AudioTrackLoader)
    app.component("convert-quiz-to-exam-link", ConvertQuizToExamLink)
    app.component("alert-dialog", AlertDialog)
    app.component("information-dialog", InformationDialog)
    app.component("versioning-video-download-button", VersioningVideoDownloadButton)
    app.component('logout', Logout)
    app.component("scorm-export-dialog", ScormExportDialog)
    app.component("fill-in-the-blanks-question-edit", FillInTheBlanksQuestionEdit)
    app.component("matching-question-edit", MatchingQuestionEdit)
    app.component("sorting-question-edit", SortingQuestionEdit)
    app.component("chapter-page-editor", ChapterPageEditor)
    app.component("chapter-document-viewer", ChapterDocumentViewer)
    app.component("answer-image-uploader-legacy-wrapper", AnswerImageUploaderLegacyWrapper)
    app.component("quiz-question-correction-editor", QuizQuestionCorrectionEditor)
    app.component("quiz-question-complementary-info-editor", QuizQuestionComplementaryInfoEditor)
    app.component("thumbnail-generator-modal", ThumbnailGeneratorModal)
    app.component("crisp-support", CrispSupport);

    /// view
    app.component("notification-page-app",NotificationPageApp);
    app.component("unsubscribe-email-notification-success",UnsubscribeEmailNotificationSuccess);
    app.component("dashboard",Dashboard);
    app.component("my-account-view",MyAccount)
    app.component("gcu-agreement-screen",GcuAgreementScreen)
    app.component("gcu-consult-screen",GcuConsultScreen)
    app.component("pdp-agreement-screen",PdpAgreementScreen)
    app.component("pdp-consult-screen",PdpConsultScreen)
    app.component("export-mass-scorm",ExportMassScorm);
    app.component("export-csv", ExportCsv);
    app.component("app-footer", Footer);
    app.component("path-editor", PathEditor);
    app.component("accessibility-statement-vue", AccessibilityStatementVue);
    app.component("accessibility-statement-edit-vue", AccessibilityStatementEditVue);
    app.component("admin-list-users", AdminListUsers);
    app.component("admin-list-speaches", AdminListSpeaches);
    app.component("weet-chapter",WeetChapter);
    app.component("weet-player-chapter",WeetPlayerChapter);
    app.component("due-date-settings", DueDateSettings);
    app.component("ai-admin-panel",AIAdminPanel);
    app.component("share-chapter-with-selector", ShareChapterWithSelector);
    app.component("create-audio-from-text", CreateAudioFromText);
    app.component("ai-speach-generator",AISpeachGenerator);
    app.component("ai-speach-generator-initiator",AISpeachGeneratorInitiator);
    app.component("generation-in-progress",GenerationInProgress);
    app.component("speach-generation-loader",SpeachGenerationLoader);
    app.component("ai-quiz-generator",AIQuizGenerator);
    app.component("workflow-validation", WorkflowValidation);
    app.component("admin-list-periodic-reviews", AdminListPeriodicReviews);
    app.component("unlock-view-settings", UnlockViewSettings);
    app.component("anonymous-workflow-submit", AnonymousWorkflowSubmit);
    app.component("open-question-quiz-player", OpenQuestionQuizPlayer);
    app.component("success-quiz-player", SuccessQuizPlayer);
    app.component("survey-quiz-player", SurveyQuizPlayer);
    app.component("poll-quiz-player", PollQuizPlayer);
    app.component("simple-quiz-player", SimpleQuizPlayer);
    app.component("exam-quiz-player", ExamQuizPlayer);
    app.component("poll-quiz-statistics", PollQuizStatistics);
    app.component("speach-poll-results", SpeachPollsResults);
    app.component("user-quizzes-results-dialog", UserQuizzesResultsDialog);
    app.component("veeva-ai-speach-loader", VeevaAISpeachLoader);
    app.component("speach-translation-settings", SpeachTranslationSettings);
    app.component("success-chapter-view", SuccessChapterView);
    app.component("open-question-chapter-view", OpenQuestionChapterView);
    app.component("demo-editor-lock", DemoEditorLock);
    app.component("demo-home", DemoHome);
    app.component("diagram-chapter-editor", DiagramChapterEditor);
    app.component("diagram-chapter-viewer", DiagramChapterViewer);

    app.mount(el);
    mountedApps.set(el, app);
}

const vueDomNodeToMountClass = "vueDomNodeToMount";
const vueDomNodeMountedClass = "vueDomNodeMounted";

/**
 * Applications vue montées par le legacy, indexées par leur noeud de montage.
 * Le legacy ne nous prévient jamais qu'il retire un noeud du DOM (etapeLayout fait des $etape.empty()
 * ou des .remove() directs), il faut donc détecter nous mêmes les applications détachées pour les
 * démonter : sans ça leurs hooks de nettoyage ne sont jamais appelés et elles retiennent leur DOM
 * (iframes des players, listeners window, ...) jusqu'au changement de page.
 */
const mountedApps = new Map<Element, App>();

/**
 * Démonte les applications dont le noeud de montage a quitté le document.
 */
const unmountDetachedApps = () => {
    for (const [el, app] of mountedApps) {
        if (!document.contains(el)) {
            mountedApps.delete(el);
            try {
                app.unmount();
            } catch (e) {
                console.warn("Error on unmount this component " + el.id, e);
            }
        }
    }
}

let unmountScheduled = false;
const observer = new MutationObserver((mutations) => {
    if (mountedApps.size === 0 || unmountScheduled) {
        return;
    }
    if (!mutations.some(mutation => mutation.removedNodes.length > 0)) {
        return;
    }
    // on attend la fin du tick courant : le legacy peut retirer puis réinsérer un noeud (déplacement
    // jquery), auquel cas l'application ne doit pas être démontée
    unmountScheduled = true;
    queueMicrotask(() => {
        unmountScheduled = false;
        unmountDetachedApps();
    });
});
observer.observe(document.documentElement, {childList: true, subtree: true});

/**
 * @param {Object} data send by speach-core (not use)
 * @param {Object} help send by speach-core (not use)
 * @param {String} clazz "class to mount"
 */
const mountVueComponent = (clazz = vueDomNodeToMountClass) => {
    const elements = document.querySelectorAll("." + clazz);

    for (const el of elements) {
        try {

            mountElement(el)
            el.classList.remove(clazz);
            el.classList.add(vueDomNodeMountedClass);
        } catch (e) {
            console.warn("Error on register this component " + el.id);
        }
    }
}
mountVueComponent();

axios.interceptors.response.use((response) => {
  redirectIfLogin(response.data);
  return response;
}, (error) => {
  console.error('Axios Error : ', error);
  if (error.response && error.response.data) {
    return Promise.reject(error.response.data);
  }
  return Promise.reject(error.message);
});

// todo found other solution to remove jquery
// @ts-ignore
$("body").off(Events.MOUNT_VUE_COMPONENT).on(Events.MOUNT_VUE_COMPONENT,(event,data)=>{
    mountVueComponent(data);
});
